"use strict";
import { useMobileMenuContent } from "components/NavBar/CompanyMenu/Content";
import { NavDropdown } from "components/NavBar/NavDropdown";
import { Link } from "react-router-dom";
import { Flex, Text, styled } from "ui/src";
import { TestID } from "test/fixtures/testIDs";
const Container = styled(Flex, {
  width: "180px",
  p: "$gap4",
  userSelect: "none",
  height: "unset",
  borderRadius: "$rounded12",
  borderColor: "$surface2Hovered"
  // backgroundColor: '$slate',
});
const LinkStyle = {
  textDecoration: "none",
  height: "unset",
  padding: 0
};
export function MenuLink({
  title,
  href,
  icon,
  closeMenu,
  isActive,
  textVariant = "subheading2",
  target = false
}) {
  const isExternal = href.startsWith("http");
  const content = <Flex
    py={"$spacing12"}
    px={"$spacing12"}
    borderRadius={"$rounded12"}
    backgroundColor={isActive ? "$surface2" : void 0}
    hoverStyle={{ backgroundColor: "$surface2" }}
    transition="background-color 0.2s ease"
    row
    alignItems="center"
    gap="$gap8"
  >
      {icon}
      <Text variant={textVariant} color={isActive ? "$neutral1" : "$neutral2"}>
        {title}
      </Text>
    </Flex>;
  if (isExternal) {
    return <a href={href} target={target ? "_blank" : "_self"} rel={target ? "noopener noreferrer" : void 0} onClick={closeMenu} style={LinkStyle}>
        {content}
      </a>;
  }
  return <Link to={href} target={target ? "_blank" : ""} onClick={closeMenu} style={LinkStyle}>
      {content}
    </Link>;
}
export function MenuDropdown({ close }) {
  const menuContent = useMobileMenuContent();
  return <NavDropdown isOpen={false} dataTestId={TestID.NavCompanyDropdown}>
      <Container>
        <Flex gap="$spacing4">
          {menuContent.map((item, index) => <MenuLink
    key={`${item.title}_${index}}`}
    title={item.title}
    target={item.target}
    href={item.href}
    icon={item.icon}
    isActive={item.isActive}
    closeMenu={close}
    internal={true}
  />)}
        </Flex>
      </Container>
    </NavDropdown>;
}
